import React from 'react';
import './App.css';
import { BrowserRouter, Link, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Dua from './pages/Dua';
import NoPage from './pages/NoPage';
import PrayerTimes from './pages/PrayerTimes';
import Header from './components/Header';
import UnderDevelopment from './pages/UnderDevelopment';
import Footer from './components/Footer';
import Blog from './pages/Blog';
import SinglePost from './components/Blog/SinglePost';
import Bookmark from './components/Blog/Bookmark';
import Composer from './components/Blog/Composer';
import { ArticleType } from './models/article.model';
import { APIBASEURL } from './common/constant';
import { useCookies } from 'react-cookie';
import { GetSS, StoreSS } from './common/sessionstorage';
import AboutUs from './pages/AboutUs';

const App: React.FunctionComponent = () => {

  const [posts, setPosts] = React.useState<ArticleType[]>([]);
  const [cookies] = useCookies(['lang']);
  const activeLanguage = cookies.lang ?? 'en';

  const handlePullArticles = React.useCallback(async (forcedb: boolean = false) => {
    let blogsSessionStorage: ArticleType[] | undefined | null;

    if (!forcedb) {
      blogsSessionStorage = GetSS("blog") as ArticleType[];
    }

    if (blogsSessionStorage && blogsSessionStorage.length > 0) {
      setPosts(blogsSessionStorage);
    }
    else {
      let blogUrl: string = "/api/Blogs/" + activeLanguage;
      try {
        const response = await fetch(APIBASEURL() + blogUrl);
        if (!response.ok) {
          throw new Error(`Failed to load blogs: ${response.status}`);
        }

        const data = await response.json() as ArticleType[];
        StoreSS("blog", data);
        setPosts(data);
      }
      catch (error) {
        console.error('Error:', error);
      }
    }
  }, [activeLanguage])

  const persistBookmark = React.useCallback(async (id: string, bookmark: boolean): Promise<boolean> => {
    try {
      const response = await fetch(`${APIBASEURL()}/api/blogbookmarks/${id}`, {
        method: bookmark ? 'PUT' : 'DELETE'
      });

      return response.ok;
    }
    catch (error) {
      console.error('Error:', error);
      return false;
    }
  }, []);

  const handleBookmark = (data: ArticleType) => {
    const previousPosts = posts;
    const bookPosts = posts.map(post => post.ID === data.ID ? ({ ...post, Bookmark: true }) : post);
    setPosts(bookPosts);
    StoreSS("blog", bookPosts);

    void persistBookmark(data.ID, true).then((ok) => {
      if (!ok) {
        setPosts(previousPosts);
        StoreSS("blog", previousPosts);
      }
    });
  }

  const handleRemoveBookmark = (data: ArticleType) => {
    const previousPosts = posts;
    const bookPosts = posts.map(post => post.ID === data.ID ? ({ ...post, Bookmark: false }) : post);
    setPosts(bookPosts);
    StoreSS("blog", bookPosts);

    void persistBookmark(data.ID, false).then((ok) => {
      if (!ok) {
        setPosts(previousPosts);
        StoreSS("blog", previousPosts);
      }
    });
  }

  const handleSubmission = (data: ArticleType) => {
    let bookPosts = [data, ...posts.filter(post => post.ID !== data.ID)];
    setPosts(bookPosts)
    StoreSS("blog", bookPosts);
  }

  const handleRemove = (post: ArticleType) => {
    let removepost = posts.filter(onepost => onepost.ID !== post.ID);
    setPosts(removepost)
    StoreSS("blog", removepost);
  }

  console.log("app init!")

  React.useEffect(() => {
    handlePullArticles();
    console.log("app mounting!")
  }, [handlePullArticles]);

  const handleFloatingMenuToggle = React.useCallback(() => {
    const element = document.getElementsByClassName('navbar-toggler')[0] as HTMLElement | undefined;
    element?.click();
  }, []);

  return (
    <>
      {
        <BrowserRouter>
          <div style={{ backgroundColor: "gainsboro" }}>
            <Header />
            <Routes>
              <Route index element={<Home />} />
              <Route path='/dua' element={<Dua />} />
              <Route path='/dua/:hash' element={<Dua />} />
              <Route path='/prayertimes' element={<PrayerTimes />} />
              <Route path='/socialservice' element={<UnderDevelopment />} />
              <Route path='/aboutus' element={<AboutUs />} />
              <Route path="/blog" element={<Blog posts={posts} handleBookmark={handleBookmark} handleRemoveBookmark={handleRemoveBookmark} />} />
              <Route path="/blog/:id" element={<SinglePost posts={posts} />} />
              <Route path="/blog/bookmark" element={<Bookmark bookmarks={posts.filter(post => post.Bookmark)} />} />
              <Route path="/blog/editor" element={<Composer posts={posts} handleBookmark={handleBookmark} handleRemoveBookmark={handleRemoveBookmark} handleSubmission={handleSubmission} handleRemove={handleRemove} />} />
              <Route path="/blog/editor/:id" element={<Composer posts={posts} handleBookmark={handleBookmark} handleRemoveBookmark={handleRemoveBookmark} handleSubmission={handleSubmission} handleRemove={handleRemove} />} />
              <Route path="*" element={<NoPage />} />
            </Routes>
            <div className="icon-bar">
              <a href="https://www.facebook.com/masjidethaqwa" target="_blank" rel="noopener noreferrer" className="social-link social-facebook" aria-label="Facebook">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://chat.whatsapp.com/6Bj4e5Xhf0r6G5VY1bQuTo" target="_blank" rel="noopener noreferrer" className="social-link social-whatsapp" aria-label="WhatsApp">
                <i className="bi bi-whatsapp"></i>
              </a>
              <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="social-link social-instagram" aria-label="Instagram">
                <i className="bi bi-instagram"></i>
              </a>
              <Link to="/dua" className="d-block d-sm-none social-link social-shortcut" aria-label="Dua page">
                <i className="fa-solid fa-hands-praying"></i>
              </Link>
              <button type="button" className="d-block d-sm-none social-link social-shortcut" id="home-floating" onClick={handleFloatingMenuToggle} aria-label="Open menu">
                <i className="bi bi-list"></i>
              </button>
              <Link to="/" className="d-block d-sm-none social-link social-shortcut" aria-label="Home page">
                <i className="bi bi-house-heart"></i>
              </Link>
            </div>
            <Footer />
          </div>
        </BrowserRouter>
      }
    </>
  );
}

export default App;

